import { IOAuthStrategy } from '@wix/sdk';
import { resolveContext } from '@wix/sdk-runtime/context';

export const resolveAuthToken = async () => {
  const res = await resolveContext()
    ?.getAuth<IOAuthStrategy>()
    .getAuthHeaders({});

  return res?.headers?.Authorization ?? '';
};
